<!--Using the mat-dialog-container here to properly style the dialog with styles from -->
<!--dialogs.scss, even though we have nested components in this dialog -->
<div class="mat-dialog-container">
  <mode-manage-access-dialog
    *ngIf="method === 'manage'"
    [collectionId]="data.collectionId"
    [collectionType]="data.collectionType"
    [workspaceName]="data.workspaceName"
    [overallAccess]="data.overallAccess"
    [showAlert]="entitlementsAdded"
    (done)="showAddMembers()"></mode-manage-access-dialog>
  <mode-add-access-dialog
    *ngIf="method === 'add'"
    [collectionId]="data.collectionId"
    [workspaceName]="data.workspaceName"
    (done)="showManageAccess($event)"></mode-add-access-dialog>
</div>
